import React from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'

export const NavLink = styled(Link)`
  font-family: Cabin-Bold, sans-serif;
  color: #737373;
  font-size: 12px;
  text-transform: uppercase;
  cursor: pointer;
  
  @media(min-width: 992px){
    font-size: 14px;
  }
  
   @media(min-width: 1200px){
     font-size: 16px;
   }
      
   @media(min-width: 1680px) {
     font-size: 19px;
   }
`;

export const Title = styled.h1`
  font-family: Cabin-Bold, sans-serif;
  font-size: 36px;
  color: #004a87;
  text-align: center;
  
  @media (min-width: 768px) {
     font-size: 26px;
  }
  
  @media(min-width: 992px) {
    font-size: 40px;
  }
  
   @media(min-width: 1200px) {
    font-size: 50px;
  }
  
   @media(min-width: 1680px) {
    font-size: 74px;
  }
`;

export const SubpageTitle = Title.extend`
  font-family: Cabin-Bold, sans-serif;
  color: #fff;
  text-align: center;
  font-size: 30px;
  
   @media (min-width: 768px) {
     font-size: 26px;
  }
  
  @media(min-width: 992px) {
    font-size: 40px;
  }
  
   @media(min-width: 1200px) {
    font-size: 50px;
  }
  
   @media(min-width: 1680px) {
    font-size: 57px;
  }
`;


export const SectionTitle = Title.extend`
  font-size: 22px;

 @media (min-width: 768px) {
     font-size: 26px;
  }
  
  @media(min-width: 992px) {
    font-size: 36px;
  }
  
  @media(min-width: 1680px) {
      font-size: 47px;
  }
`;

export const Subtitle = styled.h2`
  font-family: Cabin-SemiBold, sans-serif;
  color: #3c3c3c;
  font-size: 16px;
  z-index: 1;
 
   @media(min-width: 1200px) {
    font-size: 21px;
  }
  
   @media(min-width: 1680px) {
    font-size: 26px;
  }
`;

export const CardTitle = styled.h1`
   font-family: Cabin-Bold, sans-serif;
   font-size: 22px;
   color: #004a87;
   text-align: center;
   
   @media(min-width: 768px) {
      font-size: 26px;
   }
   
   @media(min-width: 992px) {
    font-size: 35px;
  }
`;

export const ValueTitle = CardTitle.extend`
   font-size: 22px;
   
   @media(min-width: 768px) {
      font-size: 26px;
   }
   
   @media(min-width: 992px) {
    font-size: 30px;
  }
`;

export const P1 = styled.p`
  font-family: Cabin, sans-serif;
  color: #737373;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
  z-index: 1;
  
  @media(min-width: 768px) {
    font-size: 12px;
  }
  
  @media(min-width: 992px) {
    font-size: 14px;
  }
  
   @media(min-width: 1200px) {
    font-size: 16px;
  }
  
   @media(min-width: 1680px) {
    font-size: 25px;
  }
`;

export const P2 = P1.extend`
  text-decoration: none;

  @media(min-width: 768px) {
    font-size: 12px;
  }
      
  @media(min-width: 992px) {
    font-size: 14px;
  }
  
   @media(min-width: 1200px) {
    font-size: 16px;
  }
  
   @media(min-width: 1680px) {
    font-size: 21px;
  }
  
  //added same styling due to bug from trailing slashes 
  ~ p {
      font-family: Cabin, sans-serif;
      color: #737373;
      font-size: 14px;
      line-height: 1.5;
      text-align: left;
      z-index: 1;
      
      @media(min-width: 768px) {
        font-size: 12px;
      }
          
      @media(min-width: 992px) {
        font-size: 14px;
      }
      
       @media(min-width: 1200px) {
        font-size: 16px;
      }
      
       @media(min-width: 1680px) {
        font-size: 21px;
      }
  }
`;

export const HeaderText = styled.div`
  font-family: Cabin, sans-serif;
  font-size: 25px;
`;

export const PositionTitle = styled.div`
  font-family: Cabin, sans-serif;
  font-size: 21px;
  color: #737373;
`;

export const IconTitle = styled.div`
  font-family: Cabin-Bold, sans-serif;
  color: #737373;
  font-size: 25px;
`;

export const Input = styled.input`
  border: 1px solid #e3e3e3;
  padding: 10px 0 10px 16px;
  font-family: Cabin,sans-serif;
  font-size: 14px;
  color: #004a87;
  width: 100%;
  max-width: 750px;
  
  ::placeholder{
    color: #004a87;

  }
  
  @media(min-width: 500px) {
    font-size: 21px;
  }
`;

export const OutlineButton = styled.button`
  border: 1px solid #0f558e;
  color: #004a87;
  cursor: pointer;
  width: 100%;
  background: #fff;
  font-family: Cabin-SemiBold, sans-serif;
  font-size: 14px;
  max-width: 120px;
  height: 30px;
  
  :hover{
    background: rgba(0, 74, 135, .5);
  }
  
  @media(min-width: 768px){
    max-width: 160px;
    font-size: 18px;
    height: 40px;
  }
  
   @media(min-width: 992px){
    max-width: 175px;
    height: 44px;
  }
  
  @media(min-width: 1200px){
    max-width: 190px;
    font-size: 21px;
    height: 48px;
  }
`;

export const Button = OutlineButton.extend`
  background: #004a87;
  color: #fff;
  
  :hover {
    background: #0090bf;
    filter: none;
    border: 1px solid #0090bf;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Kit/Kit.js